<template>
    <component :is="tag" class="Dialog">
        <div class="Dialog-header" v-if="!noHeader">
            <button
                v-if="!noClose"
                type="button"
                data-testid="dialog-close"
                class="btn btn--icon glass"
                @click="closeModal"
            >
                <IconX class="icon" />
            </button>

            <h1 v-if="$slots.title" class="Dialog-title">
                <slot name="title" />
            </h1>

            <div class="Dialog-action">
                <slot name="action" />
            </div>
        </div>

        <div class="Dialog-scroll">
            <slot />
        </div>
    </component>
</template>

<script lang="ts">
import { IconX } from '@tabler/icons-vue';
import { ModalElement } from 'inclusive-elements';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Dialog',

    components: {
        IconX,
    },

    props: {
        noClose: Boolean,
        noHeader: Boolean,
        tag: {
            type: String,
            default: 'div',
        },
    },

    methods: {
        closeModal(event: MouseEvent) {
            (event.target as HTMLElement | null)?.closest<ModalElement>('ui-modal')?.close();
        },
    },
});
</script>
